import { render, staticRenderFns } from "./StoreProductCategoriesList.vue?vue&type=template&id=773bfec4"
import script from "./StoreProductCategoriesList.vue?vue&type=script&lang=js"
export * from "./StoreProductCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports